import buttonDataDefaults from 'ricos-schema/dist/statics/button.defaults.json';
import { Node_Type } from 'ricos-types';
import { TOOLBARS, INSERT_PLUGIN_BUTTONS } from 'wix-rich-content-editor-common';
import { BUTTONS_TYPE_TO_TIPTAP_ATTR } from './constants.js';
import InsertPluginIcon from './icons/InsertPluginIcon.js';
import 'ricos-schema';
import './types.js';
import 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (config, _services, type) => {
  return [
    {
      id: Node_Type.BUTTON,
      label: INSERT_PLUGIN_BUTTONS.BUTTON,
      dataHook: INSERT_PLUGIN_BUTTONS.BUTTON,
      icon: InsertPluginIcon,
      tooltip: (config == null ? void 0 : config.insertButtonTooltip) || "ButtonPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ editorCommands }) => {
        editorCommands.insertBlockWithBlankLines(type, __spreadProps(__spreadValues({}, buttonDataDefaults), {
          type: BUTTONS_TYPE_TO_TIPTAP_ATTR[type]
        }));
        return true;
      },
      menuConfig: {
        tags: "Button_plugin_search_tags",
        group: "advanced"
      }
    }
  ];
};

export { getAddButtons, toolbarsToAddIn };
//# sourceMappingURL=getAddButtons.js.map
